<div class="relative h-screen overflow-hidden">
  @if (sidebar.enableSidebarPeek) {
    <div
      class="tc-sidebar-edge fixed bottom-0 left-0 top-14 z-[45] hidden w-[var(--sidebar-peek-edge)] md:block"
      aria-hidden="true"
      (mouseenter)="sidebar.onPeekEdgeEnter()"
      (mouseleave)="sidebar.onPeekEdgeLeave($event)"
    ></div>
  }

  @if (sidebar.isSidebarMobileOpen) {
    <button
      type="button"
      class="fixed inset-0 z-40 border-0 bg-black/80 p-0 md:hidden"
      aria-label="Zavřít menu"
      (click)="sidebar.closeMobileSidebar()"
    ></button>
  }

  <div
    data-tc-sidebar
    class="fixed inset-y-0 left-0 z-50 flex w-full max-w-[100vw] flex-col border-r border-sidebar-border bg-sidebar text-sidebar-foreground transition-transform duration-200 ease-linear md:w-sidebar"
    [class.translate-x-0]="sidebar.isSidebarPanelOpen"
    [class.-translate-x-full]="!sidebar.isSidebarPanelOpen"
    [class.md:shadow-none]="
      sidebar.isSidebarPeekOpen && !sidebar.isSidebarPinned
    "
    [class.pointer-events-none]="!sidebar.isSidebarPanelOpen"
    (mouseenter)="sidebar.onPeekSidebarEnter()"
    (mouseleave)="sidebar.onPeekSidebarLeave($event)"
  >
    <tc-navbar
      [user]="user"
      [logoUrl]="logoUrl"
      [brandLabel]="brandLabel"
      (toggleSidebar)="sidebar.toggleSidebar()"
      (closeSidebar)="sidebar.closeMobileSidebar()"
      (logout)="logout.emit()"
    ></tc-navbar>
  </div>

  <div
    class="content-area relative z-0 flex h-full flex-col overflow-hidden bg-background transition-[margin] duration-200 ease-linear"
    [class.md:ml-sidebar]="sidebar.isSidebarDockedOpen"
    [class.md:ml-0]="!sidebar.isSidebarDockedOpen"
  >
    <header
      data-tc-layout-header
      class="relative z-50 flex h-14 shrink-0 items-center gap-2 border-b border-border bg-background px-4"
    >
      <button
        type="button"
        data-tc-sidebar-trigger
        class="tc-sidebar-trigger inline-flex h-8 w-8 shrink-0 items-center justify-center rounded-md text-foreground transition-colors hover:bg-accent hover:text-accent-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring"
        [class.tc-sidebar-trigger--blink]="sidebar.sidebarTriggerBlink"
        [class.tc-sidebar-trigger--unlock]="sidebar.sidebarTriggerBlinkUnlock"
        [title]="
          sidebar.isMobileViewport()
            ? 'Menu'
            : sidebar.isSidebarPinned
              ? 'Odepnout menu'
              : 'Připnout menu'
        "
        [attr.aria-label]="
          sidebar.isMobileViewport()
            ? 'Menu'
            : sidebar.isSidebarPinned
              ? 'Odepnout menu'
              : 'Připnout menu'
        "
        [attr.aria-pressed]="
          !sidebar.isMobileViewport() && sidebar.isSidebarPinned
        "
        (click)="sidebar.toggleSidebar()"
      >
        <span class="tc-sidebar-trigger-icon" aria-hidden="true">
          <i class="tc-sidebar-trigger-icon__menu ri-menu-line"></i>
          <i class="tc-sidebar-trigger-icon__lock ri-lock-line"></i>
          <i class="tc-sidebar-trigger-icon__unlock ri-lock-unlock-line"></i>
        </span>
      </button>
      @if (pageTitle.title()) {
        <h1 class="m-0 min-w-0 truncate text-sm font-medium text-foreground">
          {{ pageTitle.title() }}
        </h1>
      }
      <div class="ml-auto flex shrink-0 items-center gap-3">
        <ng-content select="[tcLayoutActions]"></ng-content>
        @if (showThemeToggle) {
          <tc-theme-toggle />
        }
      </div>
      @if (showHttpLoading && httpLoading.loading()) {
        <div
          class="tc-http-loading"
          role="progressbar"
          aria-label="Načítání"
        ></div>
      }
    </header>

    <main class="tc-layout-main min-h-0 flex-1 overflow-hidden">
      <div class="tc-layout-body">
        <ng-content select="[tcLayoutBody]"></ng-content>
      </div>
    </main>
  </div>

  @if (showTourOverlay) {
    <tc-tour-overlay />
  }

  @if (showToastOutlet) {
    <tc-toast-outlet />
  }
</div>
